/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Payments_DescriptionInputs */

const en_my_payments_description = /** @type {(inputs: My_Payments_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you paid for, and your subscriptions with your trainers.`)
};

const pl_my_payments_description = /** @type {(inputs: My_Payments_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje płatności i subskrypcje u trenerów.`)
};

/**
* | output |
* | --- |
* | "What you paid for, and your subscriptions with your trainers." |
*
* @param {My_Payments_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_description = /** @type {((inputs?: My_Payments_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_description(inputs)
	return en_my_payments_description(inputs)
});